import React from 'react'
import { TabDiv } from './elementsStyles'

interface Tab_props {
  name: string
  isActive: boolean
  handleActive: (s: string) => void
}

export default function Tab({ name, isActive, handleActive }: Tab_props) {
  return (
    <TabDiv
      className={isActive ? 'active' : ''}
      active={isActive}
      onClick={() => !isActive && handleActive(name)}
    >
      {name}
    </TabDiv>
  )
}
